import './Contents.scss';
import Component from './Contents.js';
export default Component;
